// R10.5.2 — Centralized backend URL resolver.
//
// Returns the API base URL such that requests from the browser are ALWAYS
// same-origin in production. This prevents the cross-origin cookie loss
// that bounces logged-in users back to /login when the bundled
// REACT_APP_BACKEND_URL points to a different domain (preview vs prod).
//
// Behavior:
//   - SSR / no window: returns the bundled REACT_APP_BACKEND_URL verbatim.
//   - Same origin as the bundled URL: returns the bundled URL.
//   - Different origin (or missing): returns window.location.origin.
export function resolveBackend() {
  const envVal = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return envVal;
  try {
    const here = window.location.origin;
    if (!envVal) return here;
    const envOrigin = new URL(envVal).origin;
    if (envOrigin === here) return envVal;
    return here;
  } catch {
    return envVal;
  }
}

export const BACKEND = resolveBackend();
export const API = `${BACKEND}/api`;
